/**
 * fromField
 *
 * @param label      The label to display
 * @param field      allow for field to be optional since it's validity is checked inside the component regarding the allowEmpty parameter
 * @param allowEmpty allow empty parameter, defined if we throw or not an error
 *
 * @returns          JSX of the component
 */
export const FromField = (
  label: string,
  field?: string,
  allowEmpty = false,
) => {
  if (!field && !allowEmpty) {
    throw new Error(`Field [${label}] is undefined`);
  }

  return (
    <div key={label}>
      <span style={{ fontWeight: 'bold' }}>{label} : </span>
      <span style={{ marginRight: '10px' }}>{field ?? ''}</span>
    </div>
  );
};
